import { whenPurposeConsented } from '@/Utils/PrivacyUtility';
import Config from '@/Config';

/**
 * @param {object} analyticsConfig - analyticsConfig from InitialState
 */
export default function googleAdsPlugin(analyticsConfig) {
    const { googleAdsId, pageViewEventId } = analyticsConfig.googleAds;
    const platformName = Config.platformName.toLowerCase();

    whenPurposeConsented('Advertising').then(() => {
        window.gtag('config', googleAdsId, { groups: `${platformName}-ads`, cookie_domain: window.location.hostname });

        if (pageViewEventId) {
            window.gtag('event', 'conversion', { send_to: pageViewEventId, groups: `${platformName}-ads` });
        }
    });

    return {
        name: 'google-ads',
        config: analyticsConfig,
        track: () => {},
    };
}
